import React from 'react';
import Lozenge from '@atlaskit/lozenge';
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import type { TransformedDevSummary } from '../../../../../common/field-types/dev-summary';
import { TagListWrapper } from '../../../../../common/ui/tag-list-wrapper';
import messages from './messages';

export const DevSummaryLozenge = ({
	isUnderReview,
	isMerged,
	commitCount,
	pullRequestsCount,
}: TransformedDevSummary) => {
	const { formatMessage } = useIntl();

	if (isMerged || isUnderReview) {
		const tooltipText = formatMessage(messages.pullRequest, {
			count: pullRequestsCount,
		});

		const lozengeText = isMerged
			? formatMessage(messages.merged)
			: formatMessage(messages.underReview);
		const lozengeAppearance = isMerged ? 'success' : 'default';

		return (
			<TagListWrapper>
				<Tooltip content={tooltipText} position="top">
					<Lozenge appearance={lozengeAppearance}>{lozengeText}</Lozenge>
				</Tooltip>
			</TagListWrapper>
		);
	}

	if (commitCount > 0) {
		return (
			<Box xcss={linkStyles}>
				{formatMessage(messages.commit, {
					count: commitCount,
				})}
			</Box>
		);
	}
};

const linkStyles = xcss({ color: 'color.text.accent.blue', paddingLeft: 'space.075' });
